import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api, errorText } from '../api';
import { KundeFormular } from '../components/KundeFormular';
import { Badge, Card, Dialog, Empty, Loading, Notice, kundenName } from '../components/ui';
import type { Kunde } from '../types';

export function KundenPage() {
  const navigate = useNavigate();
  const [q, setQ] = useState('');
  const [kunden, setKunden] = useState<Kunde[] | null>(null);
  const [fehler, setFehler] = useState('');
  const [neu, setNeu] = useState(false);

  useEffect(() => {
    const zeit = window.setTimeout(() => {
      api<Kunde[]>('/api/kunden', { query: { q } })
        .then(setKunden)
        .catch((e) => setFehler(errorText(e)));
    }, 200);
    return () => window.clearTimeout(zeit);
  }, [q]);

  return (
    <>
      <div className="kopf">
        <h1>Kunden</h1>
        <span className="spacer" />
        <button className="primary" onClick={() => setNeu(true)}>
          + Neuer Kunde
        </button>
      </div>
      <input
        placeholder="Name, Firma, Telefon, PLZ, Ort oder Kundennummer – mehrere Wörter möglich"
        value={q}
        onChange={(e) => setQ(e.target.value)}
        autoFocus
        style={{ marginBottom: 14 }}
      />
      {fehler && <Notice kind="error">{fehler}</Notice>}
      <Card padded={false}>
        {!kunden ? (
          <Loading />
        ) : kunden.length === 0 ? (
          <Empty>{q ? 'Kein Kunde gefunden.' : 'Noch keine Kunden erfasst.'}</Empty>
        ) : (
          <div className="tabelle-wrap">
            <table>
              <thead>
                <tr>
                  <th>Kunde</th>
                  <th>Adresse</th>
                  <th>Telefon</th>
                  <th>Nr.</th>
                  <th />
                </tr>
              </thead>
              <tbody>
                {kunden.map((k) => (
                  <tr key={k.id} className="klickbar" onClick={() => navigate(`/kunden/${k.id}`)}>
                    <td>
                      <strong>{kundenName(k)}</strong>
                      {k.email && <div className="small muted">{k.email}</div>}
                    </td>
                    <td>
                      {k.strasse}
                      <div className="small muted">{[k.plz, k.ort].filter(Boolean).join(' ')}</div>
                    </td>
                    <td className="small">{(k.telefone as string[]).join(', ')}</td>
                    <td className="mono muted">{k.kundennummer}</td>
                    <td>{k.offene_tickets ? <Badge kind="warn">{k.offene_tickets} offen</Badge> : null}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </Card>
      {neu && (
        <Dialog titel="Neuer Kunde" breit onClose={() => setNeu(false)}>
          <KundeFormular
            onGespeichert={(k) => navigate(`/kunden/${k.id}`)}
            onVorhandenen={(id) => navigate(`/kunden/${id}`)}
            onAbbrechen={() => setNeu(false)}
          />
        </Dialog>
      )}
    </>
  );
}
